import AppHeader from "../../layout/AppHeader";
import BookPhotos from '../../xpost/views/umov/book.photos/BookPhotos.vue';

const BookPhotosRoutes = [
  {
    path: "/bookfotos",
    name: "book.photos",
    components: {
      header: AppHeader,
      default: BookPhotos,
    }
  },
]

export default BookPhotosRoutes;